export default {
  loading: "Punkte werden geladen...",
  errorLoad: "Punkte konnten nicht geladen werden",
  title: "Meine Punkte",
  description: "Punkte aus hochgeladenen Restaurantbelegen",
  currentBalance: "Aktuelles Guthaben",
  pointsLabel: "Punkte",
  recentTitle: "Letzte Transaktionen",
  emptyTitle: "Noch keine Punkte-Transaktionen",
  emptyDescription:
    "Laden Sie einen Restaurantbeleg hoch, um Ihre ersten Punkte zu erhalten",
} as const;
